import { REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';
import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';

import { makeRequiredQuillEditorDelta } from '../../../CorePackage/MainModule/validators/isRequiredQuillEditorDelta';
import { IKnmErknmActRemarkForm } from '../interfaces/IKnmErknmActRemarkForm';

export const getActRemarksValidate = (remarks: IKnmErknmActRemarkForm[] | undefined) => {
  return remarks?.map(r => ({
    textReactQuillEditor: r.refusedToFamiliarize
      ? undefined
      : makeRequiredQuillEditorDelta(REQUIRED_ERROR)(r?.textReactQuillEditor),
    signerFullName: r.refusedToFamiliarize ? undefined : makeRequired(REQUIRED_ERROR)(r?.signerFullName),
    signerPosition: r.refusedToFamiliarize ? undefined : makeRequired(REQUIRED_ERROR)(r?.signerPosition),
    date: r.refusedToFamiliarize ? undefined : makeRequired(REQUIRED_ERROR)(r?.date),
  }));
};
